import React from 'react'
import styled, { css } from 'styled-components'
import { mergeClassnames } from '@mote/helpers'
import { __DEV__ } from '@mote/helpers/constants'
import {
  TableBody,
  TableCell,
  TableContext,
  TableFooter,
  TableHead,
  TableRow
} from './components'

export const Table = React.forwardRef(
  (
    {
      className,
      as = 'table',
      borderless = false,
      noWrap = false,
      size = 'md',
      ...props
    },
    ref
  ) => {
    return (
      <TableContext.Provider value={{ borderless, noWrap, size }}>
        <TableRoot
          as={as}
          role={as === 'table' ? null : 'table'}
          ref={ref}
          className={mergeClassnames('mote-table', className)}
          noWrap={noWrap}
          {...props}
        />
      </TableContext.Provider>
    )
  }
)

if (__DEV__) {
  Table.displayName = 'Table'
}

const TableRoot = styled.table`
  display: table;
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  ${({ noWrap }) =>
    noWrap &&
    css`
      white-space: nowrap;
    `}
`

Table.Head = TableHead
Table.Body = TableBody
Table.Footer = TableFooter
Table.Row = TableRow
Table.Cell = TableCell
